import {QueryResult} from "@apollo/client";
import {BackendError} from "@common-core/runtime-js/backend";
import {OperationalEntity} from "@common-core/coat-operational-hierarchy-appsync-model";
import {
  LookupOperationalEntityData,
  LookupOperationalEntityVariables
} from "./LookupOperationalEntity";

export const assertOperationalEntityPresent = (
  result: QueryResult<
    LookupOperationalEntityData,
    LookupOperationalEntityVariables
  >
): OperationalEntity => {
  if (!result.data?.entity) {
    throw new BackendError(`Operational entity not found`, 404);
  }
  return result.data.entity;
};
